var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 7.44586L2.66321 0.609067C2.15817 0.104025 1.34054 0.104025 0.836793 0.609067C0.333043 1.11411 0.331751 1.93173 0.836793 2.43548L8.58679 10.1855C9.09183 10.6905 9.90946 10.6905 10.4132 10.1855L18.1632 2.43548C18.6683 1.93044 18.6683 1.11282 18.1632 0.609067C17.6582 0.105317 16.8405 0.104025 16.3368 0.609067L9.5 7.44586V7.44586Z",
    fill: "#27221D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.1ad54dd98be22efb1b037908c3510b88.svg";
export { ForwardRef as ReactComponent };